<template>
    <DForm @submit.prevent="submitForm">
        <DFormRow
            :label="__('administrations.cron_jobs.form.job')"
            :is-required="true"
            :error="errors.job"
        >
            <DSelect
                id="job"
                v-model="form.job"
                :options="jobListOptions"
                :is-valid="isFormFieldValid('job')"
            />
        </DFormRow>
        <DFormRow
            :label="__('administrations.cron_jobs.form.relevant')"
            :is-required="true"
        >
            <DSwitch
                id="relevant"
                v-model="form.relevant"
                color="success"
                variant="3d"
                inline
                @update:checked="updateActiveToggleButton"
            />
        </DFormRow>
        <DFormRow
            :label="__('administrations.cron_jobs.form.active')"
            :is-required="true"
        >
            <div
                role="group"
                class="form-group"
            >
                <DSwitch
                    v-model="form.active"
                    color="success"
                    variant="3d"
                    :disabled="form.relevant === false"
                />
            </div>
        </DFormRow>
        <DFormRow
            :label="__('administrations.cron_jobs.form.summary')"
        >
            <DFormTextarea
                id="summary"
                :value="cronJob.summary"
                class="mb-0"
                disabled
                rows="3"
            />
        </DFormRow>
        <DFormRow
            :label="__('administrations.cron_jobs.form.max_errors')"
            :is-required="true"
            :error="errors.max_errors"
        >
            <DInput
                id="max_errors"
                v-model="form.max_errors"
                :placeholder="__('administrations.cron_jobs.form.max_errors')"
                :is-valid="isFormFieldValid('max_errors')"
                type="number"
                min="0"
                max="4294967295"
            />
        </DFormRow>
        <DFormRow
            :label="__('administrations.cron_jobs.form.additional_limits')"
        >
            <DFormTextarea
                id="additional_limits"
                v-model="form.additional_limits"
                class="mb-0"
                :placeholder="__('administrations.cron_jobs.form.additional_limits')"
                :is-valid="isFormFieldValid('additional_limits')"
            />
            <div
                v-if="isFormFieldValid('additional_limits') === false"
                class="invalid-feedback d-block pb-2"
            >
                <div
                    v-for="(additionalLimitsError, index) in additionalLimitsErrors"
                    :key="index"
                >
                    {{ additionalLimitsError }}
                </div>
            </div>
        </DFormRow>
        <DFormRow
            :label="__('administrations.cron_jobs.form.emails')"
            :is-required="true"
            :error="errors.emails"
        >
            <DInput
                id="emails"
                v-model="form.emails"
                :placeholder="__('administrations.cron_jobs.form.emails')"
                :is-valid="isFormFieldValid('emails')"
                maxlength="500"
            />
        </DFormRow>
        <DFormRow
            :label="__('administrations.cron_jobs.form.rundeck_job')"
            :error="errors.rundeck_job"
        >
            <DInput
                id="rundeck_job"
                v-model="form.rundeck_job"
                :placeholder="__('administrations.cron_jobs.form.rundeck_job')"
                :is-valid="isFormFieldValid('rundeck_job')"
                maxlength="500"
            />
        </DFormRow>
        <DFormControls
            :dirty="form.isDirty"
            @submit="submitForm"
        />
    </DForm>
</template>

<script>
export default {
    name: 'CronJobForm',
    props: {
        cronJob: {
            type: Object,
            default: () => { return {} }
        },
        errors: {
            type: Object,
            default: () => { return {} }
        },
        cronJobList: {
            type: Array,
            default: () => { return [] }
        }
    },
    emits: ['form-submitted'],
    data () {
        return {
            form: this.$inertia.form({
                job: this.cronJob?.job ?? null,
                relevant: this.cronJob?.relevant ?? false,
                active: this.cronJob?.active ?? false,
                max_errors: this.cronJob?.max_errors ?? null,
                additional_limits: JSON.stringify(this.cronJob?.additional_limits, null, 6) ?? null,
                additional_limits_parsed: null,
                emails: this.cronJob?.emails ?? null,
                rundeck_job: this.cronJob?.rundeck_job ?? null
            })
        }
    },
    computed: {
        additionalLimitsErrors () {
            return this.errors.additional_limits.split('\n')
        },
        jobListOptions () {
            const list = this.cronJobList.map(job => {
                return {
                    value: job,
                    label: job
                }
            })

            list.unshift({
                value: '',
                label: ''
            })

            return list
        }
    },
    methods: {
        submitForm () {
            if (this.form.additional_limits !== null && this.form.additional_limits.length !== 0) {
                try {
                    this.form.additional_limits_parsed = JSON.parse(this.form.additional_limits)
                } catch (e) {
                    this.form.additional_limits_parsed = {}
                }
            }
            this.$emit('form-submitted', this.form)
        },
        updateActiveToggleButton (value) {
            if (value === false) {
                this.form.active = false
            }
        }
    }
}
</script>

<style scoped>

</style>
